import script from "./CommentSmall.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentSmall.vue?vue&type=script&setup=true&lang=js"

import "./CommentSmall.vue?vue&type=style&index=0&id=8233f9ea&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8233f9ea"]])

export default __exports__